// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".instructions-box .item img {\n  width: 8rem;\n}\n", ""]);
// Exports
module.exports = exports;
